import React, { useState } from 'react';
import { Collapse } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import JoinOurCommunity from '../TippingArticles/JoinOurCommunity';

import styles from './index.module.scss';
import FollowUs from '../../Common/FollowUs';
import { IconArrowShewron } from '../../Common/Icon';

const { Panel } = Collapse;

const items = [
  {
    key: '1',
    title: 'What is TippingGuide.com?',
    content: (
      <div className={styles.contentCollapse}>
        <div>
          <span>
            Our primary goal is to provide a platform for consumers and service
            workers to learn about and help shape American tipping culture. With
            the rise of electronic payments, tip screens, and an increasing
            number of industries that expect tips, many Americans feel that
            tipping culture in the U.S.A is out of control. By joining our
            online community, users can view data about tipping expectations and
            consumer averages, empowering them to make well-informed tipping
            decisions.
          </span>
        </div>
      </div>
    ),
  },
  {
    key: '2',
    title: 'What are Tipping Categories?',
    content: (
      <div>
        <span>
          The tipping categories reflect the different industries where
          Americans commonly tip. Categories are further broken down into
          subcategories, which are the specific services or occupations where
          tips may be requested.
        </span>
        <h4 className={styles.titleDesc}>
          What information can I find in Tipping Categories?
        </h4>
        <div className={styles.contentCollapse}>
          <div>
            <ul>
              <li>
                See how much other customers tip on average for different
                services
              </li>
              <li>
                Find out how much U.S. based workers in each industry expect to
                be tipped
              </li>
              <li>
                By taking our “Factors Affecting How much You Tip” survey, you
                will be able to see how other users answered the questions and
                gain further insight into tipping norms and behaviors.
              </li>
            </ul>
          </div>
          <div>
            <ul>
              <li>Share how you tip or expect to be tipped</li>
              <li>
                The comment section is for users and industry workers to share
                and discuss their opinions and questions about specific tipping
                practices, expectations, trends, and situations.
              </li>
            </ul>
          </div>
        </div>
        <h4 className={styles.titleDesc}>
          What if the service/occupation I am searching for is not listed?
        </h4>
        <span>
          We aim to provide a comprehensive list of services and occupations. If
          you cannot find the service or occupation you are looking for, please
          contact us at{' '}
          <a href="mailto:support@tippingguide.com">support@TippingGuide.com</a>{' '}
          to suggest a new category.
        </span>
        <h4 className={styles.titleDesc}>
          What is the survey “Factors Affecting Tipping Behavior”?
        </h4>
        <div className={styles.contentCollapse}>
          <div>
            <ul>
              <li>
                Answer an optional survey addressing frequently asked tipping
                questions and situations that customers often find frustrating
                or confusing.
              </li>
            </ul>
          </div>
          <div>
            <ul>
              <li>
                Upon completing the survey, you will see the results from all
                users who have completed the survey.
              </li>
            </ul>
          </div>
        </div>
        <h4 className={styles.titleDesc}>
          What is the “Service Workers” Survey?
        </h4>
        <div className={styles.contentCollapse}>
          <div>
            <ul>
              <li>
                This survey is for U.S. based workers only, who receive or
                expect tips at their job.
              </li>
            </ul>
          </div>
          <div>
            <ul>
              <li>
                The results of this survey are shown in the graph as “Worker
                Average.”
              </li>
            </ul>
          </div>
        </div>

        <h4 className={styles.titleDesc}>
          Can I respond to the Worker Survey for more than one tipped industry?
        </h4>
        <div className={styles.contentCollapse}>
          <div>
            <ul>
              <li>
                If you are a U.S. based worker, working in more than one tipped
                industry (or have in the past 2 years) you can provide feedback
                for up to two occupations.
              </li>
            </ul>
          </div>
          <div>
            <ul>
              <li>
                Your feedback is highly encouraged and crucial to helping users
                understand tipping norms and expectations in the United States.{' '}
              </li>
            </ul>
          </div>
        </div>

        <h4 className={styles.titleDesc}>
          Why do I need an account to provide feedback?
        </h4>
        <div className={styles.contentCollapse}>
          <div>
            <ul>
              <li>
                The integrity and reliability of our data is extremely
                important. We want to provide our users with the most accurate
                data possible. Therefore, we require that users make an account
                to provide feedback.
              </li>
            </ul>
          </div>
          <div></div>
        </div>
      </div>
    ),
  },
  {
    key: '3',
    title: 'What is Share Your Two Cents?',
    content: (
      <div>
        <div className={styles.contentCollapse}>
          <div>
            <ul>
              <li>
                This section is designed to facilitate conversations about tip
                requests or service fees at real businesses, providing valuable
                information to current or potential customers. It also allows
                business owners to understand how their customers feel about
                their tipping policies and how it may be affecting their
                business.
              </li>
              <li>
                This section allows users to post pictures of tip screens,
                receipts with tip requests, or service fees, etc. from different
                businesses and leave a comment.
              </li>
              <li>
                Users can also search for specific businesses in their area or
                worldwide.
              </li>
            </ul>
          </div>
          <div>
            <ul>
              <li>
                Users can filter by city, state, U.S. zip code, or country to
                read posts about businesses in specific areas.
              </li>
              <li>
                Business owners are able to claim their business and respond to
                customers and posts. Their status as Business Owner will be
                shown in blue.
              </li>
            </ul>
          </div>
        </div>
        <h4 className={styles.titleDesc}>
          How do I create a post on Share Your Two Cents?
        </h4>
        <div className={styles.contentCollapse}>
          <div>
            <ul>
              <li>
                Click on “Create New Post” from the Share Your Two Cents page
              </li>
              <li>Search for a business by name or zip code.</li>
              <li>
                Select Category and Subcategory for the business from the drop
                down menu.
              </li>{' '}
              <li>
                If the category or subcategory you are searching for is not
                available, please contact us at{' '}
                <a href="mailto:support@tippingguide.com">
                  support@TippingGuide.com
                </a>
                .
              </li>
            </ul>
          </div>
          <div>
            <ul>
              <li>
                Upload a photo of a tip screen, receipt displaying tip
                suggestions, service fees, tip policies, or anything tipping
                related.
              </li>
              <li>Leave a comment (optional)</li>
              <li>When finished, click “Submit”</li>
              <li>
                You will see a preview of your post as it will appear on the
                site. You are able to edit your post, if necessary.
              </li>
            </ul>
          </div>
        </div>
        <h4 className={styles.titleDesc}>
          What if I can’t find the category or subcategory of a business?
        </h4>

        <div className={styles.contentCollapse}>
          <div>
            <ul>
              <li>
                Please email us at{' '}
                <a href="mailto:support@tippingguide.com">
                  support@TippingGuide.com
                </a>
                , we will respond with either a suggested existing subcategory
                or create a new subcategory.
              </li>
            </ul>
          </div>
          <div></div>
        </div>
      </div>
    ),
  },
  {
    key: '4',
    title: 'How does the Tip Calculator work?',
    content: (
      <div className={styles.contentCollapse}>
        <div>
          <ul>
            <li>
              Using the drop down menu, select the industry/ service you are
              tipping for.
            </li>
            <li>
              Once a service is selected, the customer and worker average tip
              percentage will be displayed (these amounts are calculated based
              on data provided by TippingGuide.com users in the U.S. and can
              also be found on the Tipping Category pages).
            </li>
          </ul>
        </div>
        <div>
          <ul>
            <li>
              You can select either the customer or worker average tip
              percentage or enter any percentage you would like to tip.
            </li>
            <li>Enter the bill total.</li>
            <li>
              If you're sharing the bill with others, you can use the 'split
              bill' feature.
            </li>
            <li>
              The calculator will then provide the tip and total (or split tip
              and total).
            </li>
          </ul>
        </div>
      </div>
    ),
  },
  {
    key: '5',
    title: 'What is All About Tipping?',
    content: (
      <div>
        <div className={styles.contentCollapse}>
          <div>
            <ul>
              <li>
                This section includes Tipping Articles, History of Tipping, and
                Psychology of Tipping.
              </li>
              <li>
                Here you can find answers to many of the most commonly asked
                questions about tipping.
              </li>
            </ul>
          </div>
          <div>
            <ul>
              <li>
                Can't find information about a topic you're interested in?
                Contact us at
                <a href="mailto:info@tippingguide.com">
                  info@tippingguide.com
                </a>{' '}
                to suggest an article topic.
              </li>
            </ul>
          </div>
        </div>

        <div>
          <h4 className={styles.titleDesc}>What is the Articles section?</h4>
          <span>
            Articles in this section address some of the most frequently asked
            questions about tipping and cover a variety of topics including:
            trends and technology in tipping, economic and social issues, ethics
            and controversy, psychological and sociological aspects, cultural
            and global perspectives, and interviews with real industry workers
            about tipping in their industry.
          </span>
        </div>
      </div>
    ),
  },
];

export default function FAQContent(): React.ReactElement {
  const [activeKey, setActiveKey] = useState<string | string[]>('1');

  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <div className={styles.header}>
            <div className={styles.title}>
              <h1>FAQ</h1>
              <span>
                We’re here to answer your questions and provide support.
                <br />
                Let us know how we can assist you!
              </span>
            </div>
            <div className={styles.followUs}>
              <FollowUs />
            </div>
          </div>
          <div className={styles.content}>
            <Collapse
              activeKey={activeKey}
              onChange={(key) => setActiveKey(key)}
              bordered={false}
              expandIconPosition="end"
              // eslint-disable-next-line react/no-unstable-nested-components
              expandIcon={({ isActive }) => (
                <IconArrowShewron
                  rotate={isActive ? 270 : 90}
                  style={{
                    fontSize: 14,
                    color: isActive ? '#11B559' : '#282C35',
                    transform: isActive ? 'rotate(360deg)' : 'rotate(180deg)',
                    transition: 'transform 0.3s ease',
                  }}
                />
              )}
              className={styles.collapse}
            >
              {items.map(({ key, title, content }) => (
                <Panel
                  key={key}
                  header={
                    <span
                      className={styles.panelHeader}
                      // style={{ color: activeKey === key ? '#49cf6d' : '#1c1c1c' }}
                      style={{
                        color: activeKey.includes(key) ? '#11B559' : '#282C35',
                      }}
                    >
                      <h3>
                        {key}. {title}
                      </h3>
                    </span>
                  }
                >
                  {content}
                </Panel>
              ))}
            </Collapse>
          </div>
        </div>
      </div>
      <JoinOurCommunity />
    </>
  );
}
